module.exports = __webpack_public_path__ + "img/金牌@2x.cdab8542.png";